'use client';

import { useMemo } from 'react';
import { APOLLO_ERROR_POLICY, APOLLO_FETCH_POLICY } from '@/constants/apollo';
import { setDefaultHeader } from '@/publicSearch/graphql/headers';
import {
  useGetAnimalPedigreeQuery,
  GetAnimalPedigreeQuery,
} from '@/publicSearch/graphql/queries.generated';
import { mapPedigreeResponse } from '@/components/publicSearch/animal/pedigreeAdapter';

export function useAnimalPedigree(
  animalId: string,
  orgId?: string | number,
  maxGen = 5,
) {
  const numericAnimalId = Number(animalId);
  const shouldSkip = !animalId || Number.isNaN(numericAnimalId) || !orgId;

  const { data, loading, error } = useGetAnimalPedigreeQuery({
    skip: shouldSkip,
    variables: {
      animalId: numericAnimalId,
      maxGen,
    },
    context: {
      headers: setDefaultHeader(orgId),
    },
    errorPolicy: APOLLO_ERROR_POLICY.ALL,
    fetchPolicy: APOLLO_FETCH_POLICY.NETWORK_ONLY,
  });

  const rootNode = useMemo(
    () => mapPedigreeResponse(data?.pedigree),
    [data?.pedigree],
  );

  return {
    data: rootNode,
    loading,
    error,
    raw: data as GetAnimalPedigreeQuery | undefined,
  };
}
